// extracted by mini-css-extract-plugin
export var successStories = "SuccessStories-module--successStories--2lRM2";
export var successStories__title = "SuccessStories-module--successStories__title--2Xvyd";
export var successStories__visibItem = "SuccessStories-module--successStories__visibItem--2ishP";
export var successStories__bell = "SuccessStories-module--successStories__bell--2S7pj";
export var successStories__rocket = "SuccessStories-module--successStories__rocket--2t5uW";
export var successStories__arrow = "SuccessStories-module--successStories__arrow--3hLc6";
export var successStories__arrowPrev = "SuccessStories-module--successStories__arrowPrev--2w3CL";
export var successStories__arrowNext = "SuccessStories-module--successStories__arrowNext--1AZKY";
export var successStories__items = "SuccessStories-module--successStories__items---uqRg";